var map = {
	"./Actions.js": 8,
	"./Constants.js": 26,
	"./authoredCalcs.js": 214,
	"./calcs/2018/calculator_node.js": 849,
	"./calcs/2018/categories.js": 268,
	"./calcs/2018/data-structures/Budget Model (orig) - Budget Projections.js": 850,
	"./calcs/2018/data-structures/Budget Model (orig) - Initial Budget Projections.js": 851,
	"./calcs/2018/data-structures/Economic Model (orig) - Budget Calculator Baseline Values.js": 852,
	"./calcs/2018/data-structures/Economic Model (orig) - Budget Calculator Benchmark Values.js": 853,
	"./calcs/2018/data-structures/Economic Model (orig) - CBO Assumed.js": 570,
	"./calcs/2018/data-structures/Economic Model (orig) - Macroeconomic Feedback Calculations.js": 854,
	"./calcs/2018/data-structures/Weighted Interest On Debt.js": 855,
	"./calcs/2018/data-structures/bc_hc components calc (orig).js": 856,
	"./calcs/2018/data-structures/bc_oasdhi rev model (orig).js": 857,
	"./calcs/2018/data-structures/bc_other mandatory (orig).js": 858,
	"./calcs/2018/data-structures/bc_ss outlay model (orig).js": 859,
	"./calcs/2018/data-structures/cbo_10_year.js": 568,
	"./calcs/2018/data-structures/cbo_lt_budget.js": 860,
	"./calcs/2018/data-structures/cbo_lt_econ.js": 569,
	"./calcs/2018/growthOptions.js": 571,
	"./calcs/2018/growthSettings.js": 861,
	"./calcs/2018/prepare.js": 862,
	"./calcs/2018/sheets.js": 526,
	"./calcs/2018/technicalAssumptions.js": 359,
	"./calcs/2019_01/categories.js": 269,
	"./calcs/2019_01/data-structures/Budget Model (orig) - Budget Projections.js": 866,
	"./calcs/2019_01/data-structures/Budget Model (orig) - Initial Budget Projections.js": 867,
	"./calcs/2019_01/data-structures/Economic Model (orig) - Budget Calculator Baseline Values.js": 868,
	"./calcs/2019_01/data-structures/Economic Model (orig) - Budget Calculator Benchmark Values.js": 869,
	"./calcs/2019_01/data-structures/Economic Model (orig) - CBO Assumed.js": 870,
	"./calcs/2019_01/data-structures/Economic Model (orig) - Macroeconomic Feedback Calculations.js": 871,
	"./calcs/2019_01/data-structures/Weighted Interest On Debt.js": 872,
	"./calcs/2019_01/data-structures/bc_hc components calc (orig).js": 873,
	"./calcs/2019_01/data-structures/bc_oasdhi rev model (orig).js": 874,
	"./calcs/2019_01/data-structures/bc_other mandatory (orig).js": 875,
	"./calcs/2019_01/data-structures/bc_ss outlay model (orig).js": 876,
	"./calcs/2019_01/data-structures/cbo_10_year.js": 877,
	"./calcs/2019_01/data-structures/cbo_lt_budget.js": 878,
	"./calcs/2019_01/data-structures/cbo_lt_econ.js": 879,
	"./calcs/2019_01/growthOptions.js": 572,
	"./calcs/2019_01/growthSettings.js": 880,
	"./calcs/2019_01/prepare.js": 881,
	"./calcs/2019_01/sheets.js": 527,
	"./calcs/2019_01/technicalAssumptions.js": 573,
	"./calcs/2019_06/categories.js": 270,
	"./calcs/2019_06/data-structures/Budget Model (orig) - Budget Projections.js": 882,
	"./calcs/2019_06/data-structures/Budget Model (orig) - Initial Budget Projections.js": 883,
	"./calcs/2019_06/data-structures/Economic Model (orig) - Budget Calculator Baseline Values.js": 884,
	"./calcs/2019_06/data-structures/Economic Model (orig) - Budget Calculator Benchmark Values.js": 885,
	"./calcs/2019_06/data-structures/Economic Model (orig) - CBO Assumed.js": 886,
	"./calcs/2019_06/data-structures/Economic Model (orig) - Macroeconomic Feedback Calculations.js": 887,
	"./calcs/2019_06/data-structures/Weighted Interest On Debt.js": 888,
	"./calcs/2019_06/data-structures/bc_hc components calc (orig).js": 889,
	"./calcs/2019_06/data-structures/bc_oasdhi rev model (orig).js": 890,
	"./calcs/2019_06/data-structures/bc_other mandatory (orig).js": 891,
	"./calcs/2019_06/data-structures/bc_ss outlay model (orig).js": 892,
	"./calcs/2019_06/data-structures/cbo_10_year.js": 893,
	"./calcs/2019_06/data-structures/cbo_lt_budget.js": 894,
	"./calcs/2019_06/data-structures/cbo_lt_econ.js": 895,
	"./calcs/2019_06/growthOptions.js": 574,
	"./calcs/2019_06/growthSettings.js": 896,
	"./calcs/2019_06/prepare.js": 897,
	"./calcs/2019_06/sheets.js": 528,
	"./calcs/2019_06/technicalAssumptions.js": 575,
	"./calcs/2019_08/categories.js": 271,
	"./calcs/2019_08/data-structures/Budget Model (orig) - Budget Projections.js": 898,
	"./calcs/2019_08/data-structures/Budget Model (orig) - Initial Budget Projections.js": 899,
	"./calcs/2019_08/data-structures/Economic Model (orig) - Budget Calculator Baseline Values.js": 900,
	"./calcs/2019_08/data-structures/Economic Model (orig) - Budget Calculator Benchmark Values.js": 901,
	"./calcs/2019_08/data-structures/Economic Model (orig) - CBO Assumed.js": 902,
	"./calcs/2019_08/data-structures/Economic Model (orig) - Macroeconomic Feedback Calculations.js": 903,
	"./calcs/2019_08/data-structures/Weighted Interest On Debt.js": 904,
	"./calcs/2019_08/data-structures/bc_hc components calc (orig).js": 905,
	"./calcs/2019_08/data-structures/bc_oasdhi rev model (orig).js": 906,
	"./calcs/2019_08/data-structures/bc_other mandatory (orig).js": 907,
	"./calcs/2019_08/data-structures/bc_ss outlay model (orig).js": 908,
	"./calcs/2019_08/data-structures/cbo_10_year.js": 909,
	"./calcs/2019_08/data-structures/cbo_lt_budget.js": 910,
	"./calcs/2019_08/data-structures/cbo_lt_econ.js": 911,
	"./calcs/2019_08/growthOptions.js": 576,
	"./calcs/2019_08/growthSettings.js": 912,
	"./calcs/2019_08/prepare.js": 913,
	"./calcs/2019_08/sheets.js": 529,
	"./calcs/2019_08/technicalAssumptions.js": 577,
	"./calcs/2019_08_tax/categories.js": 273,
	"./calcs/2019_08_tax/data-structures/Budget Model (orig) - Budget Projections.js": 914,
	"./calcs/2019_08_tax/data-structures/Budget Model (orig) - Initial Budget Projections.js": 915,
	"./calcs/2019_08_tax/data-structures/Economic Model (orig) - Budget Calculator Baseline Values.js": 916,
	"./calcs/2019_08_tax/data-structures/Economic Model (orig) - Budget Calculator Benchmark Values.js": 917,
	"./calcs/2019_08_tax/data-structures/Economic Model (orig) - CBO Assumed.js": 918,
	"./calcs/2019_08_tax/data-structures/Economic Model (orig) - Macroeconomic Feedback Calculations.js": 919,
	"./calcs/2019_08_tax/data-structures/Weighted Interest On Debt.js": 920,
	"./calcs/2019_08_tax/data-structures/bc_hc components calc (orig).js": 921,
	"./calcs/2019_08_tax/data-structures/bc_oasdhi rev model (orig).js": 922,
	"./calcs/2019_08_tax/data-structures/bc_other mandatory (orig).js": 923,
	"./calcs/2019_08_tax/data-structures/bc_ss outlay model (orig).js": 924,
	"./calcs/2019_08_tax/data-structures/cbo_10_year.js": 925,
	"./calcs/2019_08_tax/data-structures/cbo_lt_budget.js": 926,
	"./calcs/2019_08_tax/data-structures/cbo_lt_econ.js": 927,
	"./calcs/2019_08_tax/data-structures/tc_baseline.js": 928,
	"./calcs/2019_08_tax/data-structures/tc_change_growthrates.js": 929,
	"./calcs/2019_08_tax/data-structures/tc_change_options.js": 930,
	"./calcs/2019_08_tax/growthOptions.js": 578,
	"./calcs/2019_08_tax/growthSettings.js": 931,
	"./calcs/2019_08_tax/prepare.js": 932,
	"./calcs/2019_08_tax/sheets.js": 530,
	"./calcs/2019_08_tax/technicalAssumptions.js": 579,
	"./calcs/2020_01/categories.js": 274,
	"./calcs/2020_01/data-structures/Budget Model (orig) - Budget Projections.js": 933,
	"./calcs/2020_01/data-structures/Budget Model (orig) - Initial Budget Projections.js": 934,
	"./calcs/2020_01/data-structures/Economic Model (orig) - Budget Calculator Baseline Values.js": 935,
	"./calcs/2020_01/data-structures/Economic Model (orig) - Budget Calculator Benchmark Values.js": 936,
	"./calcs/2020_01/data-structures/Economic Model (orig) - CBO Assumed.js": 937,
	"./calcs/2020_01/data-structures/Economic Model (orig) - Macroeconomic Feedback Calculations.js": 938,
	"./calcs/2020_01/data-structures/Weighted Interest On Debt.js": 939,
	"./calcs/2020_01/data-structures/bc_hc components calc (orig).js": 940,
	"./calcs/2020_01/data-structures/bc_oasdhi rev model (orig).js": 941,
	"./calcs/2020_01/data-structures/bc_other mandatory (orig).js": 942,
	"./calcs/2020_01/data-structures/bc_ss outlay model (orig).js": 943,
	"./calcs/2020_01/data-structures/cbo_10_year.js": 944,
	"./calcs/2020_01/data-structures/cbo_lt_budget.js": 945,
	"./calcs/2020_01/data-structures/cbo_lt_econ.js": 946,
	"./calcs/2020_01/growthOptions.js": 580,
	"./calcs/2020_01/growthSettings.js": 947,
	"./calcs/2020_01/prepare.js": 948,
	"./calcs/2020_01/sheets.js": 531,
	"./calcs/2020_01/technicalAssumptions.js": 581,
	"./calcs/2020_09/categories.js": 275,
	"./calcs/2020_09/data-structures/Budget Model (orig) - Budget Projections.js": 949,
	"./calcs/2020_09/data-structures/Budget Model (orig) - Initial Budget Projections.js": 950,
	"./calcs/2020_09/data-structures/Economic Model (orig) - Budget Calculator Baseline Values.js": 951,
	"./calcs/2020_09/data-structures/Economic Model (orig) - Budget Calculator Benchmark Values.js": 952,
	"./calcs/2020_09/data-structures/Economic Model (orig) - CBO Assumed.js": 953,
	"./calcs/2020_09/data-structures/Economic Model (orig) - Macroeconomic Feedback Calculations.js": 954,
	"./calcs/2020_09/data-structures/Weighted Interest On Debt.js": 955,
	"./calcs/2020_09/data-structures/bc_hc components calc (orig).js": 956,
	"./calcs/2020_09/data-structures/bc_oasdhi rev model (orig).js": 957,
	"./calcs/2020_09/data-structures/bc_other mandatory (orig).js": 958,
	"./calcs/2020_09/data-structures/bc_ss outlay model (orig).js": 959,
	"./calcs/2020_09/data-structures/cbo_10_year.js": 960,
	"./calcs/2020_09/data-structures/cbo_lt_budget.js": 961,
	"./calcs/2020_09/data-structures/cbo_lt_econ.js": 962,
	"./calcs/2020_09/data-structures/tc_baseline.js": 963,
	"./calcs/2020_09/data-structures/tc_change_growthrates.js": 964,
	"./calcs/2020_09/data-structures/tc_change_options.js": 965,
	"./calcs/2020_09/growthOptions.js": 582,
	"./calcs/2020_09/growthSettings.js": 966,
	"./calcs/2020_09/prepare.js": 967,
	"./calcs/2020_09/sheets.js": 532,
	"./calcs/2020_09/technicalAssumptions.js": 583,
	"./camelCase.js": 213,
	"./categoryFunctions.js": 20,
	"./categorymeta.js": 218,
	"./colors.js": 190,
	"./components/Account.js": 407,
	"./components/ActionBar.js": 220,
	"./components/AddFeaturedCalc.js": 410,
	"./components/Admin.js": 411,
	"./components/AnimatedPath.js": 245,
	"./components/AnimatedRect.js": 71,
	"./components/App.js": 413,
	"./components/ArticleListItem.js": 469,
	"./components/Authenticate.js": 462,
	"./components/AuthenticateOrSkip.js": 463,
	"./components/Authors.js": 1181,
	"./components/Budget.js": 442,
	"./components/BudgetChange.js": 473,
	"./components/BudgetChanges.js": 474,
	"./components/BudgetCircle.js": 1182,
	"./components/BudgetGrowthRateSelect.js": 448,
	"./components/BudgetMeta.js": 1183,
	"./components/BudgetSnapshot.js": 234,
	"./components/CalculatorTile.js": 466,
	"./components/Calculators.js": 408,
	"./components/Category.js": 446,
	"./components/CategoryDetail.js": 452,
	"./components/CategoryHeader.js": 92,
	"./components/CategorySnapshot.js": 66,
	"./components/CategoryTrail.js": 236,
	"./components/CategoryValueInYear.js": 1184,
	"./components/Counter.js": 97,
	"./components/DefaultEdit.js": 1185,
	"./components/DisplayYearSelect.js": 1200,
	"./components/DisplayYearSlider.js": 235,
	"./components/DoneEditing.js": 454,
	"./components/Econ.js": 450,
	"./components/EconGrowthRateSelect.js": 451,
	"./components/EconTrend.js": 475,
	"./components/EconTrendChart.js": 185,
	"./components/Edit.js": 441,
	"./components/EditBudgetActionBar.js": 1201,
	"./components/EditBudgetMeta.js": 460,
	"./components/EditBudgetMetaModal.js": 459,
	"./components/EditForm.js": 461,
	"./components/EditMetaButton.js": 1202,
	"./components/Email.js": 425,
	"./components/Facebook.js": 423,
	"./components/FeaturedArticles.js": 468,
	"./components/FeaturedCalcsAdmin.js": 412,
	"./components/FeaturedCalculators.js": 465,
	"./components/FullCarousel.js": 1203,
	"./components/Group.js": 246,
	"./components/GrowthRatePercentageInput.js": 153,
	"./components/GrowthRateSelect.js": 237,
	"./components/GrowthRateSettings.js": 447,
	"./components/GrowthSlider.js": 449,
	"./components/HamburgerMenu.js": 439,
	"./components/HeroChart/Choices.js": 416,
	"./components/HeroChart/HoverTargets.js": 222,
	"./components/HeroChart/Legend.js": 445,
	"./components/HeroChart/XAxis.js": 223,
	"./components/HeroChart/YAxis.js": 224,
	"./components/HeroChart/chart-button-controls.js": 227,
	"./components/HeroChart/chart-datum.js": 149,
	"./components/HeroChart/chart-dropdown-controls.js": 226,
	"./components/HeroChart/chart.js": 225,
	"./components/HeroChart/index.js": 52,
	"./components/HeroChart/super-hero-chart.js": 221,
	"./components/HeroChart/tooltips.js": 444,
	"./components/Home.js": 464,
	"./components/Image.js": 470,
	"./components/Lightswitch.js": 1204,
	"./components/LinkedIn.js": 426,
	"./components/Loading.js": 151,
	"./components/Login.js": 436,
	"./components/Nav.js": 311,
	"./components/NewBudgetActionBar.js": 1205,
	"./components/Policy.js": 238,
	"./components/PolicyList.js": 453,
	"./components/PolicyRecap.js": 1206,
	"./components/Profile.js": 409,
	"./components/Projections.js": 443,
	"./components/QuickChange.js": 455,
	"./components/QuickChanges.js": 240,
	"./components/RadioGroup.js": 1207,
	"./components/ResetButton.js": 1208,
	"./components/ResetCalcButton.js": 1209,
	"./components/RoundButton.js": 1210,
	"./components/SaveButton.js": 232,
	"./components/ScrollToTopOnMount.js": 103,
	"./components/SegmentedBar.js": 1211,
	"./components/ShareModal.js": 228,
	"./components/SlideToggleButton.js": 150,
	"./components/SpendingVsRevenue.js": 476,
	"./components/StickyTop.js": 1212,
	"./components/Styleguide.js": 471,
	"./components/Tables.js": 472,
	"./components/TreeMap.js": 1213,
	"./components/Tutorial.js": 233,
	"./components/Twitter.js": 424,
	"./components/UserChanges.js": 239,
	"./components/VideoModal.js": 229,
	"./components/ViewBudget.js": 1214,
	"./components/accordion/accordion.js": 372,
	"./components/accordion/index.js": 422,
	"./components/embed/Embed.js": 393,
	"./components/embed/app/app.js": 394,
	"./components/embed/app/directory.js": 479,
	"./components/embed/app/index.js": 634,
	"./components/embed/app/instance.js": 314,
	"./components/embed/changeTypes.js": 106,
	"./components/embed/changes/changes.js": 398,
	"./components/embed/changes/index.js": 1219,
	"./components/embed/demoData.js": 1220,
	"./components/embed/entry-point/entry-point.js": 396,
	"./components/embed/entry-point/index.js": 481,
	"./components/embed/final/final.js": 395,
	"./components/embed/final/index.js": 480,
	"./components/embed/index.js": 486,
	"./components/embed/questions/index.js": 482,
	"./components/embed/questions/progress.js": 483,
	"./components/embed/questions/question.js": 485,
	"./components/embed/questions/questions.js": 397,
	"./components/embed/questions/status.js": 484,
	"./components/icons/AccountIcon.js": 437,
	"./components/icons/AmericaOffBalanceIcon.js": 79,
	"./components/icons/CalculatorIcon.js": 104,
	"./components/icons/Changes.js": 457,
	"./components/icons/CheckIcon.js": 1221,
	"./components/icons/Close.js": 61,
	"./components/icons/CtaArrow.js": 477,
	"./components/icons/Dashboard.js": 458,
	"./components/icons/DeleteIcon.js": 148,
	"./components/icons/DescribeIcon.js": 241,
	"./components/icons/Down.js": 467,
	"./components/icons/DownloadIcon.js": 230,
	"./components/icons/EconSettingsIcon.js": 1222,
	"./components/icons/EditIcon.js": 147,
	"./components/icons/Gear.js": 1223,
	"./components/icons/HamburgerIcon.js": 438,
	"./components/icons/InfoIcon.js": 440,
	"./components/icons/ResetCircleIcon.js": 456,
	"./components/icons/ResetIcon.js": 478,
	"./components/icons/Save.js": 433,
	"./components/icons/SelectCaret.js": 102,
	"./components/icons/ShareIcon.js": 231,
	"./components/icons/Twitter.js": 1224,
	"./components/icons/ViewIcon.js": 219,
	"./components/icons/slide_toggle_arrow.js": 421,
	"./components/next-arrow-icon.js": 152,
	"./components/report/budget-changes.js": 418,
	"./components/report/calc-header.js": 429,
	"./components/report/category-changes.js": 419,
	"./components/report/controls.js": 430,
	"./components/report/footer.js": 431,
	"./components/report/index.js": 414,
	"./components/report/policy.js": 420,
	"./components/report/projections.js": 415,
	"./components/report/report-header.js": 428,
	"./components/report/report.js": 370,
	"./components/report/unsaved.js": 432,
	"./components/tax-calc/chart.js": 435,
	"./components/tax-calc/index.js": 434,
	"./components/tax-calc/tax-calc.js": 388,
	"./configureStore.js": 404,
	"./definitions.js": 11,
	"./difference.js": 49,
	"./downloadVariables.js": 399,
	"./fb.js": 28,
	"./formatDollars.js": 5,
	"./formulas.js": 19,
	"./hooks/useBreakpoint.js": 417,
	"./hooks/useFetch.js": 242,
	"./hooks/useMeasure.js": 1225,
	"./index.js": 496,
	"./localStorage.js": 315,
	"./normalize.js": 14,
	"./operations.js": 10,
	"./processors.js": 338,
	"./reducers/calculator.js": 405,
	"./reducers/helpers.js": 131,
	"./reducers/session.js": 487,
	"./reducers/setCategoriesToDefault.js": 406,
	"./registerServiceWorker.js": 1227,
	"./renderCalc.js": 243,
	"./rounding.js": 95,
	"./versions.js": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;